function isTouchDevice() {
   var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
   var mq = function (query) {
      return window.matchMedia(query).matches;
   };
   if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
      return true;
   }
   var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
   return mq(query);
}

function jlInitSlider() {
   
   new Flickity('.jl-marquee__list', {
      draggable: true,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: true,
      wrapAround: true,
   });

   function initProductPageSlider() {
      const productSliderArr = Array.from(document.querySelectorAll('[data-product-featured]'));

      if(productSliderArr.length === 0) return;

      productSliderArr.forEach(slider => {
         let flkty = new Flickity(slider, {
            pageDots: false,
            imagesLoaded: true,
            wrapAround: true,
            arrowShape: 'M25.5882 3L3 25.9169M3 25.9169L25.5882 49M3 25.9169L51 25.9169',
         });

         if (isTouchDevice()) {
            // pinch zoom initialize
            let pz = [];
            const imageContainer = Array.from(slider.querySelectorAll('.product-single__slide'));
            imageContainer.forEach(el => {
               pz.push(new PinchZoom.default(el));
            });
            let mc = new Hammer.Manager(slider);
            let pinch = new Hammer.Pinch();

            mc.add([pinch]);

            // disable Flickity slider swipe on pinch start
            mc.on('pinchstart', function (ev) {
               flkty.options.draggable = false;
               flkty.updateDraggable();
            });

            // enable Flickity slider swipe on pinch end
            mc.on('pinchend', function (ev) {
               flkty.options.draggable = true;
               flkty.updateDraggable();
            });
         }
         
      });

      const productThumbsArr = Array.from(document.querySelectorAll('[data-product-thumb]'));
      productThumbsArr.forEach(thumbs => {
         const thumbSlidesArr = Array.from(thumbs.querySelectorAll('.product-single__thumbnail-slider'));
         if(thumbSlidesArr.length <= 5) {
            thumbs.classList.add('jl-thumbs-fixed-pos');
         }
         new Flickity(thumbs, {
            pageDots: false,
            imagesLoaded: true,
            cellAlign: 'left',
            asNavFor: thumbs.closest('.product-single__photos').querySelector('[data-product-featured]'),
            wrapAround: true,
            prevNextButtons: false,
            draggable: false,
         });
      });
   }

   initProductPageSlider();

   $('.jl-reviews__list').each(function () {
      $(this).slick({
         infinite: true,
         slidesToShow: 1,
         arrows: true,
         autoplay: true,
         nextArrow: $(this).closest('.jl-carousel').find('.jl-carousel__btn--next'),
         prevArrow: $(this).closest('.jl-carousel').find('.jl-carousel__btn--prev'),
      });
   });

   function initCarouselSlider() {

      if($('.jl-carousel__list:not(.jl-carousel__list--async)').length === 0) return;
      $('.jl-carousel__list:not(.jl-carousel__list--async)').each(function() {
         $(this).slick({
            infinite: true,
            slidesToShow: 4,
            arrows: true,
            autoplay: true,
            nextArrow: $(this).closest('.jl-carousel').find('.jl-carousel__btn--next'),
            prevArrow: $(this).closest('.jl-carousel').find('.jl-carousel__btn--prev'),
         });        
      });

      window.addEventListener('resize', function () {
         if (window.innerWidth <= 767) {
            $('.jl-carousel__list:not(.jl-carousel__list--async)').each(function() {
               $(this).slick('unslick');
            })
         }
      });
   }

   function initFeatureSlider() {

      if($('.jl-features__list--slider').length === 0) return;

      $('.jl-features__list--slider').slick({
         dots: false,
         infinite: true,
         speed: 300,
         slidesToShow: 1,
         slidesToScroll: 1,
         autoplay: true,
         arrows: true,
         nextArrow: $('.jl-features__list--slider').closest('.jl-features__carousel').find('.jl-carousel__btn--next'),
         prevArrow: $('.jl-features__list--slider').closest('.jl-features__carousel').find('.jl-carousel__btn--prev'),
      });

      window.addEventListener('resize', function () {
         if (window.innerWidth > 767) {
            $('.jl-features__list--slider').slick('unslick');
         }
      });
   }

   function initOrderStepsSlider() {

      if($('.jl-orderSteps__carouselList').length === 0) return;

      $('.jl-orderSteps__carouselList').slick({
         dots: true,
         infinite: false,
         speed: 300,
         slidesToShow: 1,
         slidesToScroll: 1,
         autoplay: false,
         arrows: false,
      });

      window.addEventListener('resize', function () {
         if (window.innerWidth > 767) {
            $('.jl-orderSteps__carouselList').slick('unslick');
         } 
      });
   }

  function initAlternateGridSlider() {

      if($('.js-jl-alternateGrid').length === 0) return;

      $('.js-jl-alternateGrid').slick({
         dots: true,
         infinite: true,
         speed: 1000,
         slidesToShow: 1,
         slidesToScroll: 1,
         autoplay: false,
         arrows: true,
         prevArrow: '<button type="button" class="prev-arrow slick-arrow"><svg fill=none stroke=#000 stroke-width=1.5 viewBox="0 0 24 24"xmlns=http://www.w3.org/2000/svg><path d="M15.75 19.5 8.25 12l7.5-7.5"stroke-linecap=round stroke-linejoin=round /></svg></button>',
         nextArrow: '<button type="button" class="next-arrow slick-arrow"><svg fill=none stroke=#000 stroke-width=1.5 viewBox="0 0 24 24"xmlns=http://www.w3.org/2000/svg><path d="m8.25 4.5 7.5 7.5-7.5 7.5"stroke-linecap=round stroke-linejoin=round /></svg></button>',
      });

      window.addEventListener('resize', function () {
         if (window.innerWidth > 767) {
            $('.js-jl-alternateGrid').slick('unslick');
         } 
      });
   }

   if (window.innerWidth <= 767) {
      initFeatureSlider();
      initOrderStepsSlider();
      initAlternateGridSlider();

      window.addEventListener('resize', function () {
         if (window.innerWidth <= 767) {
            initFeatureSlider();
            initOrderStepsSlider();
            initAlternateGridSlider();
         } else {
            initCarouselSlider();
         }
      });

   } else {
      initCarouselSlider();
      window.addEventListener('resize', function () {
         if (window.innerWidth <= 767) {
            initFeatureSlider();
            initOrderStepsSlider();
            initAlternateGridSlider();
         } else {
            initCarouselSlider();
         }
      });
   }
}

//------------------------------------ ACCORDION START ------------------------------------- //
function jlInitAccordion() {
   const accordions = Array.from(document.querySelectorAll('.js-faq-accordion'));

   if(accordions.length === 0) return;

   new Accordion(accordions, {
      duration: 400,
      showMultiple: false,
   });
}
//------------------------------------ ACCORDION END ------------------------------------- //

//------------------------------------ NAVIGATION START ------------------------------------- //

function jlInitModalToggle() {
   const navTrigger = document.querySelector('.js-navMobileTrigger');
   const navBtnClose = document.querySelector('.js-navMobileClose');
   const navDrawer = document.querySelector('.jl-navMobile__drawer');
   const overlay = document.querySelector('.jl-overlay');

   const btnDropdownTriggerArr = Array.from(document.querySelectorAll('.jl-navMobile__btnDropdownTrigger'));

   navTrigger.addEventListener('click', function () {
      this.classList.toggle('jl-navMobile__trigger--active');
      navDrawer.classList.toggle('jl-navMobile__drawer--active');
      overlay.classList.toggle('jl-overlay--active');
      overlay.classList.toggle('jl-overlay--behind');

      document.querySelector('body').classList.toggle('overflow-hidden');
   });

   overlay.addEventListener('click', removeActiveClasses);
   navBtnClose.addEventListener('click', removeActiveClasses);

   function removeActiveClasses() {
      const activePopup = document.querySelector('.js-modal--active');

      if (navDrawer.classList.contains('jl-navMobile__drawer--active')) {
         navDrawer.classList.remove('jl-navMobile__drawer--active');
         navTrigger.classList.remove('jl-navMobile__trigger--active');
         overlay.classList.remove('jl-overlay--behind');
      }

      if (activePopup) {
         activePopup.classList.remove('js-modal--active');
      }

      overlay.classList.remove('jl-overlay--active');
      document.querySelector('body').classList.remove('overflow-hidden');
   }

   // navbar drawer dropdown functionality
   btnDropdownTriggerArr.forEach(btn => {
      btn.addEventListener('click', function () {
         this.closest('.jl-navMobile__linkItem')
            .querySelector('.jl-navMobile__dropdown')
            .classList.toggle('jl-navMobile__dropdown--active');

         this.classList.toggle('jl-navMobile__btnDropdownTrigger--active');
      });
   });

   function popupToggle() {
      const btnOpenArr = document.querySelectorAll('.js-openPopup');

      btnOpenArr.forEach(btn => {
         btn.addEventListener('click', function () {
            const modalName = btn.dataset.modalName;
            const modal = document.querySelector(`.js-modal[data-modal-name=${modalName}]`);
            const btnClose = modal.querySelector('.js-btnClose');

            modal.classList.add('js-modal--active');
            overlay.classList.add('jl-overlay--active');
            document.querySelector('body').classList.toggle('overflow-hidden');
            btnClose.addEventListener('click', removeActiveClasses);
         });
      });
   }

   popupToggle();
      
}

//------------------------------------ NAVIGATION END ------------------------------------- //

//------------------------------------ TABS TOGGLE START ------------------------------------- //
function jlInitToggleTabs() {
   const btnToggleArr = Array.from(document.querySelectorAll('.js-tabs__tab'));
   if(!btnToggleArr.length) return;
   const parent = btnToggleArr[0].closest('.js-tabs');

   // Make size guide popup tab active as per the category of the product functionality
   for (let i = 0; i < window.productCollection.length; i++) {
      const collection = window.productCollection[i];
      if(collection.includes('ring')) {
         // by default ring tab is first and it is selected - so do nothing
         break;
      }
      if(collection.includes('necklace')) {
         removeActiveTabClass();
         document.querySelector('[data-product-type="necklace"]').classList.add('js-tabs__tabContent--active');
         document.querySelector('[data-button-product-type="necklace"]').classList.add('js-tabs__tab--active');
         break;
      }
      if(collection.includes('bracelet')) {
         removeActiveTabClass();
         document.querySelector('[data-product-type="bracelet"]').classList.add('js-tabs__tabContent--active');
         document.querySelector('[data-button-product-type="bracelet"]').classList.add('js-tabs__tab--active');
         break;
      }   
   }

   btnToggleArr.forEach(btn => {
      btn.addEventListener('click', function () {
         removeActiveTabClass();
         btn.classList.add('js-tabs__tab--active');
         const tabIndex = btn.dataset.tab;
         parent.querySelector(`.js-tabs__tabContent--${tabIndex}`).classList.add('js-tabs__tabContent--active');
      });
   });

   function removeActiveTabClass() {
      parent.querySelector('.js-tabs__tab--active').classList.remove('js-tabs__tab--active');
      parent.querySelector('.js-tabs__tabContent--active').classList.remove('js-tabs__tabContent--active');
   }
}
//------------------------------------ TABS TOGGLE END ------------------------------------- //

//------------------------------------ NOTIFICATIONS START ------------------------------------- //
// function jlInitNotifications() {
//    const notificationEl = document.querySelector('.jl-notifications');
//    const notificationWrapperArr = notificationEl.querySelectorAll('.jl-notification__inner');
//    let currentActiveContentIndex = 0;
//    const initialDelay = 5000;
//    const subsequentRenderInterval = 10000;
//    const visibleTime = 5000;
//    const btnClose = document.querySelector('.jl-notifications__btnClose');
//    let interval = null;

//    const showNotification = () => {
//       notificationEl.querySelector('.jl-notification__inner--active').classList.remove('jl-notification__inner--active');
//       currentActiveContentIndex++;
//       if(currentActiveContentIndex >= notificationWrapperArr.length) currentActiveContentIndex = 0;
//       notificationWrapperArr[currentActiveContentIndex].classList.add('jl-notification__inner--active');
//       notificationEl.classList.add('jl-notifications--visible');
//    }
//    const hideNotification = () => notificationEl.classList.remove('jl-notifications--visible');

//    setTimeout(() => {
//       showNotification();
//       startRenderCycles();
//       setTimeout(() => hideNotification(), visibleTime);
//    }, initialDelay);

//    function startRenderCycles() {
//       interval = setInterval(() => {
//          showNotification();
//          setTimeout(() => hideNotification(), visibleTime);
//       }, subsequentRenderInterval);
//    }

//    btnClose.addEventListener('click', function () {
//       hideNotification();
//       clearInterval(interval);
//    });
// }
//------------------------------------ NOTIFICATIONS END ------------------------------------- //

function toggleSearchBar() {
   const btnEl = document.querySelector('.jl-header__btnSearch');
   const searchEl = document.querySelector('.jl-header__search');

   document.querySelector('body').addEventListener('click', function(e) {
      // toggle search bar visible class
      
      if(e.target.closest('.jl-header__btnSearch')) {
         
         searchEl.classList.toggle('visible');
        document.querySelector('.jl-header__search .search-header__input').focus();
        console.log('calling input')
          return;
      }
      // prevent search close on click of search input
      if(e.target.closest('.jl-header__search') || !searchEl.classList.contains('visible')) return;
      // remove visible class on click anywhere on body
      searchEl.classList.remove('visible');
   })
}

function focusInput() {
   $("#searchform input").focus();
} 

function pdpStickyBarToggle() {
   const watchElement = document.querySelector('.product-single__meta .jl-ATC');
   const targetEl = document.querySelector('.jl-stickyatc');

   showOnScroll(targetEl, watchElement);

   function showOnScroll(targetEl, watchElement) {
      elementClassToggle();
      window.addEventListener('scroll', function () {
         elementClassToggle();
      });
      function elementClassToggle() {
         if (watchElement) {
            if (isElementAboveViewport(watchElement)) {
               targetEl.classList.remove('visible');
            } else {
               targetEl.classList.add('visible');
            }
         }
      }
      function isElementAboveViewport(element) {
         var rect = element.getBoundingClientRect();
         return !(rect.bottom < 0);
      }
   }
}

function pdpZoomImageOnHover() {
   const imageContainer = document.querySelector('.jl-product__slider');
   if(!imageContainer || window.innerWidth < 992) return; // if we are not on product page or not on desktop devices do not continue

   const overlay = document.querySelector(".zoom-img-container");
   const mouseOverlay = document.querySelector(".zoom-mouse-overlay");

   //hides overlay
   const hideElement = () => {
      overlay.style.display = 'none';
      mouseOverlay.style.display = 'none';
   };

   const showElement = () => {
      overlay.style.display = 'block';
      mouseOverlay.style.display = 'inline-block';
   }

   imageContainer.addEventListener('mouseover', showElement);
   imageContainer.addEventListener('mouseout', hideElement);
   imageContainer.addEventListener('mousemove', e => {
      //Try, catch to avoid any errors for touch screens
      try {
         let x = e.pageX;
         let y = e.pageY;
         let clientY = e.clientY;
         const rect = imageContainer.getBoundingClientRect();
         let imageWidth = rect.width;
         let imageHeight = rect.height;
         let offsetLeft = rect.left;
         let offsetTop = rect.top;
         let posX = ((x - offsetLeft) / imageWidth).toFixed(4) * 100;
         let posY = ((clientY - offsetTop) / imageHeight).toFixed(4) * 100;

         const hoverImage = document.querySelector('.product-single__slide.is-selected img').dataset.zoom;
         overlay.style.backgroundImage = `url(${hoverImage})`;

         //set background position to above obtained values
         overlay.style.backgroundPosition = posX + '%' + posY + '%';

         //move the overlay with cursor
         mouseOverlay.style.top = y + 'px';
         mouseOverlay.style.left = x + 'px';
      } catch (e) {}
   });
}

function jlInitApp() {
   jlInitSlider();
   jlInitAccordion();
   jlInitModalToggle();
   jlInitToggleTabs();
   // jlInitNotifications();
   toggleSearchBar();
   pdpStickyBarToggle();
   pdpZoomImageOnHover();

   window.addEventListener('resize', () => {
      pdpZoomImageOnHover();
   });
}

window.addEventListener('DOMContentLoaded', jlInitApp);


$('.js-related-articles-slide').slick({
   infinite: true,
   slidesToShow: 4,
   arrows: true,
   autoplay: true,
   prevArrow: '<button type="button" class="slick-arrow preview-arrow"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.496547 7.44524C0.106023 7.83576 0.106023 8.46892 0.496547 8.85945L6.86051 15.2234C7.25103 15.6139 7.8842 15.6139 8.27472 15.2234C8.66525 14.8329 8.66525 14.1997 8.27472 13.8092L2.61787 8.15234L8.27472 2.49549C8.66525 2.10496 8.66525 1.4718 8.27472 1.08128C7.8842 0.690751 7.25103 0.690751 6.86051 1.08128L0.496547 7.44524ZM15.7969 7.15234L1.20365 7.15234L1.20365 9.15234L15.7969 9.15234L15.7969 7.15234Z" fill="black"/></svg></button>',
   nextArrow: '<button type="button" class="slick-arrow next-arrow"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5035 8.55476C15.894 8.16424 15.894 7.53107 15.5035 7.14055L9.13949 0.776588C8.74897 0.386064 8.1158 0.386064 7.72528 0.776588C7.33475 1.16711 7.33475 1.80028 7.72528 2.1908L13.3821 7.84766L7.72528 13.5045C7.33475 13.895 7.33475 14.5282 7.72528 14.9187C8.1158 15.3092 8.74897 15.3092 9.13949 14.9187L15.5035 8.55476ZM0.203125 8.84766H14.7963V6.84766H0.203125V8.84766Z" fill="black"/></svg></button>',
   responsive: [
      {
         breakpoint: 1199,
         settings: {
         slidesToShow: 3,
         slidesToScroll: 1,          
         }
      },
      {
         breakpoint: 767,
         settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
         }
      },
      {
         breakpoint: 340,
         settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
         }
      }
   ]
});

$('.js-our-latest-creations-slide').slick({
   infinite: true,
   slidesToShow: 4,
   arrows: true,
   autoplay: false,
   prevArrow: '<button type="button" class="slick-arrow preview-arrow"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.496547 7.44524C0.106023 7.83576 0.106023 8.46892 0.496547 8.85945L6.86051 15.2234C7.25103 15.6139 7.8842 15.6139 8.27472 15.2234C8.66525 14.8329 8.66525 14.1997 8.27472 13.8092L2.61787 8.15234L8.27472 2.49549C8.66525 2.10496 8.66525 1.4718 8.27472 1.08128C7.8842 0.690751 7.25103 0.690751 6.86051 1.08128L0.496547 7.44524ZM15.7969 7.15234L1.20365 7.15234L1.20365 9.15234L15.7969 9.15234L15.7969 7.15234Z" fill="black"/></svg></button>',
   nextArrow: '<button type="button" class="slick-arrow next-arrow"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5035 8.55476C15.894 8.16424 15.894 7.53107 15.5035 7.14055L9.13949 0.776588C8.74897 0.386064 8.1158 0.386064 7.72528 0.776588C7.33475 1.16711 7.33475 1.80028 7.72528 2.1908L13.3821 7.84766L7.72528 13.5045C7.33475 13.895 7.33475 14.5282 7.72528 14.9187C8.1158 15.3092 8.74897 15.3092 9.13949 14.9187L15.5035 8.55476ZM0.203125 8.84766H14.7963V6.84766H0.203125V8.84766Z" fill="black"/></svg></button>',
   responsive: [
      {
         breakpoint: 1199,
         settings: {
         slidesToShow: 3,
         slidesToScroll: 1,          
         }
      },
      {
         breakpoint: 767,
         settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
         }
      },
      {
         breakpoint: 340,
         settings: {
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
         }
      }
   ]
});

// Video Play same section
// const video = $(".js-nightmare-collection-video")[0];
// $(document).on('click', '.btn-video-play', function(){
//     if (video.paused || video.ended) {
//         video.play();
//     } else {
//         video.pause();
//     }
// });
$(".jl-btnVideo").on('click', function(ev){
   ev.preventDefault();
    $('.slideshow-wrapper').hide();
    $(".background-iframe-video")[0].src += "&autoplay=1";
    $('.background-iframe-video, .background-iframe-video-close').show();
});
$(".background-iframe-video-close").on('click', function(){
    $('.slideshow-wrapper').show();
    $('.background-iframe-video, .background-iframe-video-close').hide();
});
// end Video Play same section

// review load more
$(".jdgm-all-reviews__body .jdgm-rev").slice(0, 6).show();
$(document).on(`click`, `.js-load-more-btn`, function(e) {
   e.preventDefault();
   console.log('loader')
   $(".jdgm-all-reviews__body .jdgm-rev:hidden").slice(0, 6).slideDown("slow");
   if ($(".jdgm-all-reviews__body .jdgm-rev:hidden").length == 0) {
      $(".jdgm-all-reviews__body .js-load-more-btn").hide();
   } 
});
// review load more end

// 05-01-2024

// out of box close sidebar
$(document).mouseup(function(e) {
   var container = $(".jl-side-cart");

   // if the target of the click isn't the container nor a descendant of the container
   if (!container.is(e.target) && container.has(e.target).length === 0) 
   {
       container.removeClass("open");
       $("body").removeClass("scroll-hidden");
   }
});
// end out of box close sidebar 

// trigger click
$(document).on(`click`, `.js-openPopup-trigger`, function (e) {
   e.preventDefault();
   $('.js-openPopup').trigger('click');
});
// end trigger click
// end 05-01-2024
jQuery(document).ready(function($) {
  setTimeout(function() {
    const buttonText = document.querySelector('.jl-btn-custom-text');
    if (buttonText) {
      buttonText.textContent = 'To Add To Cart, please view this product on our Etsy store.';
    }
  }, 1500); // Adjust the delay if needed
});
